



































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SfHeading',
  props: {
    level: {
      type: Number,
      default: 2,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  hasDescription(descriptionProp, slots) {
    return !!descriptionProp || slots().description;
  },
  headingClass(headingLevel) {
    return headingLevel <= 6 ? `h${headingLevel}` : 'h2';
  },
});
